import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth må brukes innenfor AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [takstmann, setTakstmann] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Sjekk om bruker er logget inn
    const token = localStorage.getItem('token');
    const savedTakstmann = localStorage.getItem('takstmann');

    if (token && savedTakstmann) {
      setTakstmann(JSON.parse(savedTakstmann));
    }
    setLoading(false);
  }, []);

  const login = async (epost, passord) => {
    try {
      const response = await authAPI.login({ epost, passord });
      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('takstmann', JSON.stringify(user));
      setTakstmann(user);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Innlogging feilet',
      };
    }
  };

  const register = async (userData) => {
    try {
      const response = await authAPI.register(userData);
      const { token, user } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('takstmann', JSON.stringify(user));
      setTakstmann(user);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Registrering feilet',
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('takstmann');
    setTakstmann(null);
  };

  const value = {
    takstmann,
    loading,
    login,
    register,
    logout,
    isAuthenticated: !!takstmann,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
